import React from 'react';
import { compose } from 'ramda';
import { RouteComponentProps } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
// import queryString from 'query-string';
import { ProjectCard as ProjectCardLayout } from '@deeptrue-frontend/ui';

import { FormatMessage } from 'components/IntlProvider/hooks/hooks';
import { ProjectStatus } from 'consts/statuses';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import ProjectAdminActions from 'components/Projects/ProjectAdminActions';
// import api from 'api/api';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { useFormatMessage } from 'components/IntlProvider';
import { OrganizationType } from 'store/modules/auth/auth';
import { ProjectType } from 'store/modules/projects/projects.types';
import { Button } from '@deeptrue-frontend/ui';

const { connect, actions, selectors } = StoreProvider;
const { withRouter } = RouterProvider;

export const STATUSES = {
  [`${ProjectStatus.OFFER_DRAFT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerDraft.action', 'Accept'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerDraft.status', 'Draft'),
  },
  [`${ProjectStatus.OFFER_ACCEPTED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerAccepted.ACCEPTED', 'Run'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerAccepted.ACCEPTED', 'Draft'),
  },
  [`${ProjectStatus.OFFER_REFUSED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerRefused.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerRefused.status', 'Refused'),
  },
  [`${ProjectStatus.OFFER_CANCELLED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerCancelled.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerCancelled.status', 'Cancelled'),
  },
  [`${ProjectStatus.PRODUCTS_SENT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.productsSent.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.productsSent.status', 'Products sent'),
  },
  [`${ProjectStatus.SURVEYS_SENT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.surveysSent.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.surveysSent.status', 'Surveys sent'),
  },
  [`${ProjectStatus.SURVEYS_RECEIVED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.surveysReceived.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.surveysReceived.status', 'Surveys received'),
  },
  [`${ProjectStatus.INVOICE_SENT}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.invoiceSent.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.invoiceSent.status', 'Invoice'),
  },
  [`${ProjectStatus.ANALYSIS_DONE}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.analysisDone.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.analysisDone.status', 'Completed'),
  },
  [`${ProjectStatus.PAYMENT_DONE}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.paymentDone.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.paymentDone.status', 'Paid'),
  },
  [`${ProjectStatus.FINISHED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.finished.action', 'Archive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.finished.status', 'Completed'),
  },
  [`${ProjectStatus.OFFER_ARCHIVED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.offerArchived.action', 'Unarchive'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.offerArchived.status', 'Archived'),
  },
  [`${ProjectStatus.COLLECTING_DATA}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.collectingData.action', 'Running'),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.collectingData.status', 'Collecting Data'),
  },
  [`${ProjectStatus.SUSPENDED}`]: {
    actionText: (t: FormatMessage) =>
      t('projects.statuses.suspended.action', ''),
    statusText: (t: FormatMessage) =>
      t('projects.statuses.suspended.status', 'Suspended'),
  },
};

interface ProjectCardProps extends RouteComponentProps<any> {
  name: string;
  progress: number | null;
  id: number;
  createdAt: string;
  updatedAt: string;
  brand: string;
  status: number;
  url?: string;
  userOrganization: OrganizationType;
  clearProject: () => void;
  setOrganizationProjects: (project: ProjectType) => void;
  setUserProjects: (project: ProjectType) => void;
  link: string;
  lang: string;
  toolName: string;
  productName: string;
}

const ProjectCard = ({
  name,
  id,
  createdAt,
  status,
  // userOrganization,
  match,
  progress,
  // setOrganizationProjects,
  // setUserProjects,
  // location,
  lang,
  productName,
  history,
}: ProjectCardProps) => {
  const t = useFormatMessage();
  // const parsedSearch = queryString.parse(location.search);

  // const refreshProjectList = () => {
  //   if (match.params.codename) {
  //     return api.resources
  //       .getOrganizationProjects({
  //         organization_name: match.params.codename,
  //         params: parsedSearch as { limit: string; offset: string },
  //       })
  //       .then(({ data }) => {
  //         setOrganizationProjects(data);
  //       });
  //   }

  //   return api.resources
  //     .userProjects({ organizationName: userOrganization.codename })
  //     .then(({ data }) => {
  //       setUserProjects(data);
  //     });
  // };

  // const actionProject = (
  //   e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  // ) => {
  //   e.stopPropagation();
  //   e.preventDefault();

  //   if (status === 1) {
  //     return api.resources
  //       .acceptProjects({
  //         id,
  //         organization_name: match.params.codename || userOrganization.codename,
  //       })
  //       .finally(() => {
  //         refreshProjectList().finally(() => {
  //           clearProject();
  //         });
  //       });
  //   }

  //   if (status === 2) {
  //     return api.resources
  //       .collectProjectData({
  //         organizationCodename:
  //           match.params.codename || userOrganization.codename,
  //         id,
  //       })
  //       .finally(() => {
  //         refreshProjectList().finally(() => {
  //           clearProject();
  //         });
  //       });
  //   }

  //   return;
  // };

  const templateUrl = match.params.codename
    ? `/admin/organizations/${match.params.codename}/projects/${id}/review`
    : `/project/${id}/review`;

  return (
    <Grid item xs={12} md={6} lg={4} style={{ padding: '1rem' }}>
      <ProjectCardLayout
        name={name}
        id={id}
        createdAt={createdAt}
        progress={progress}
        status={status}
        statusText={STATUSES[status.toString()].statusText(t)}
        menu={
          <ProjectAdminActions id={id} projectName={name} status={status} />
        }
        lang={lang}
        createdText={t('projects.card.created', 'Created')}
        completedText={t('projects.card.completed', 'completed')}
        toolName={productName}
      >
        <Button onClick={() => history.push(templateUrl)} variant="label">
          {t('projects.card.projectDetails', 'Project details')} -&gt;
        </Button>
      </ProjectCardLayout>
    </Grid>
  );
};
export default compose(
  connect(
    (state) => ({
      userOrganization: selectors.authSelectors.userOrganization(state),
    }),
    {
      setOrganizationProjects:
        actions.organizationsActions.setOrganizationProjects,
      setUserProjects: actions.projects.setProjects,
      clearProject: actions.projects.clearProject,
    }
  ),
  withRouter
)(ProjectCard);
